export const SERVER_SCHEMA_IDS = {
  // primitives
  PAGE_ANCHOR: 'https://traegergrills.com/data/contentTypes/pageAnchor.json',
  ARTICLE: 'https://traegergrills.com/data/contentTypes/article.json',
  CHIP_BAR: 'https://traeger.com/v2/chipBar.json',
  BANNER: 'https://traegergrills.com/data/contentTypes/banner.json',

  // components
  PRODUCT_COMPARISON: 'https://traeger.com/v2/view/productComparison.json',
  CONTENT_GRID: 'https://traeger.com/v2/grid.json',
  GENERAL_NESTED_SLOT: 'https://traegergrills.com/data/nestedSlot/general.json',
  INDEX_BODY: 'https://traegergrills.com/data/slot/indexBody.json',
  GENERAL_BODY: 'https://traegergrills.com/data/nestedSlot/generalBody.json',
  STORY: 'https://traegergrills.com/data/contentTypes/story.json',
  SPLIT_BACKGROUND: 'https://traegergrills.com/data/contentTypes/splitBackground.json',
  FIXED_BACKGROUND_CONTAINER: 'https://traegergrills.com/data/contentTypes/fixedBackgroundContainer.json',
  GENERAL_REFERENCE_CAROUSEL: 'https://traegergrills.com/data/contentTypes/generalReferenceCarousel.json',
  RECOMMENDED_ACCESSORIES: 'https://traegergrills.com/data/contentTypes/recommendedAccessories.json',
  RECOMMENDED_PRODUCTS: 'https://traegergrills.com/data/contentTypes/recommendedProducts.json',
  CASCADING_CARDS: 'https://traegergrills.com/data/contentTypes/cascadingCards.json',
  RELATED_PRODUCT_GRID: 'https://traegergrills.com/data/contentTypes/relatedProductGrid.json',
  PRODUCT_GRID: 'https://traegergrills.com/data/contentTypes/productGrid.json',
  NAVBAR: 'https://traegergrills.com/data/slot/navbar.json',
  CALLOUT_GRID: 'https://traegergrills.com/data/contentTypes/calloutGrid.json',
  TRAEGER_TV_PLAYLIST: 'https://traegergrills.com/data/contentTypes/traegerTVPlaylist.json',
  THREE_COLUMN_CONTENT: 'https://traegergrills.com/data/contentTypes/threeColumnContent.json',
  CAREERS_JOB_POSTINGS: 'https://traegergrills.com/data/contentTypes/careersJobPostings.json',
  FEATURED_VIDEO: 'https://traegergrills.com/data/contentTypes/featuredVideo.json',
  GRILL_CAPACITY_AND_MEASUREMENT: 'https://traegergrills.com/data/contentTypes/grillCapacityAndMeasurement.json',
  GRILL_RECOMMENDATION_RESULT: 'https://traegergrills.com/data/contentTypes/grillRecommendationResult.json',
  HALF_SPLIT_CAROUSEL: 'https://traegergrills.com/data/contentTypes/halfSplitContentCarousel.json',
  SPOTLIGHT_CAROUSEL: 'https://traegergrills.com/data/contentTypes/spotlightCarousel.json',
  IMAGE_SECTION: 'https://traeger.com/v2/imageSection.json',
  THREE_CARD_STACK: 'https://traeger.com/v2/threeCardStack.json',
  EMAIL_CAPTURE: 'https://traeger.com/v2/emailCapture.json',
  GENERAL_HALF_SPLIT: 'https://traegergrills.com/data/contentTypes/generalHalfSplitContent.json',
  CALLOUT_SLIDER: 'https://traegergrills.com/data/contentTypes/calloutSlider.json',
  DEALER_LOCATOR: 'https://traegergrills.com/data/contentTypes/dealerLocator.json',
  FAQ_ACCORDION: 'https://traegergrills.com/data/contentTypes/faqAccordion.json',
  GRILL_FEATURE_COMPARISON: 'https://traegergrills.com/data/contentTypes/grillFeatureComparison.json',
  COOKING_PLANNER: 'https://traegergrills.com/data/contentTypes/cookingPlanner.json',
  CATEGORY_GRID: 'https://traegergrills.com/data/contentTypes/categoryGrid.json',

  // views
  RECIPE_CATEGORY_BODY: 'https://traegergrills.com/data/slot/recipeCategoryBody.json',
  LEARN_CATEGORY_BODY: 'https://traegergrills.com/data/slot/learnCategoryBody.json',
  PAGE: 'https://traeger.com/v2/view/page.json',
  AUTHOR: 'https://traegergrills.com/data/contentTypes/author.json',
  RECIPE: 'https://traegergrills.com/data/contentTypes/recipe.json',
  PRODUCT: 'https://traegergrills.com/data/contentTypes/product.json',
  LEARN: 'https://traegergrills.com/data/contentTypes/learn.json',
  ADMINISTRATIVE: 'https://traegergrills.com/data/contentTypes/administrative.json',
  LEARN_OVERVIEW_BODY: 'https://traegergrills.com/data/slot/learnOverviewBody.json',
  PRODUCT_OVERVIEW_BODY: 'https://traegergrills.com/data/slot/productOverviewBody.json',
  RECIPE_OVERVIEW_BODY: 'https://traegergrills.com/data/slot/recipeOverviewBody.json',
  TRAEGER_TV_CATEGORY_BODY: 'https://traegergrills.com/data/slot/traegerTVCategoryBody.json',
  ERROR_BODY: 'https://traegergrills.com/data/slot/404body.json',
  FORGOT_PASSWORD: 'https://traegergrills.com/data/contentTypes/userForgotPassword.json',
  ACCOUNT_DASHBOARD: 'https://traegergrills.com/v2/accountDashboard.json',
  USER_AUTH: 'https://traegergrills.com/data/contentTypes/userAuth.json',
} as const

export const CLIENT_SCHEMA_IDS = {
  // primitives
  CALLOUT_GRID_CARD: 'https://traegergrills.com/data/contentTypes/calloutGridCard.json',
  SERIES_TITLE_AND_TEXT: 'https://traegergrills.com/data/contentTypes/seriesTitleAndText.json',
  SINGLE_COLUMN_TEXT: 'https://traegergrills.com/data/contentTypes/singleColumnText.json',
  FULL_WIDTH_ASSET: 'https://traegergrills.com/data/contentTypes/fullWidthAsset.json',
  FLEX_CONTAINER: 'https://traeger.com/v2/flexContainer.json',
  BIO_HEADER_CARD: 'https://traegergrills.com/data/contentTypes/bioHeaderCard.json',
  LIFESTYLE_BANNER: 'https://traegergrills.com/data/contentTypes/lifestyleBanner.json',
  PROMO_BANNER: 'https://traegergrills.com/data/contentTypes/promoBanner.json',
  TWO_THIRDS_TEXT: 'https://traegergrills.com/data/contentTypes/twoThirdsSplitText.json',

  // components
  FUEL_HERO: 'https://traegergrills.com/data/contentTypes/fuelHero.json',
  SAVED_RECIPES: 'https://traeger.com/v2/savedRecipes.json',
  GRILL_HERO: 'https://traegergrills.com/data/contentTypes/grillHero.json',
  GENERAL_HERO_BANNER_WITH_SEARCH: 'https://traegergrills.com/data/contentTypes/generalHeroBannerWithSearch.json',
  GENERAL_HERO_BANNER_WITH_BUTTON: 'https://traegergrills.com/data/contentTypes/generalHeroBannerWithButton.json',
  TIER_TWO_HERO: 'https://traeger.com/v2/tierTwoHero.json',
  GENERAL_HERO_BANNER_WITH_LINKS: 'https://traegergrills.com/data/contentTypes/generalHeroBannerWithLinks.json',
  GENERAL_HERO_BANNER_WITH_TEXT: 'https://traegergrills.com/data/contentTypes/generalHeroBannerWithText.json',
  GENERAL_HERO_BANNER_WITH_LOGO: 'https://traegergrills.com/data/contentTypes/generalHeroBannerWithLogo.json',
  ORDER_TRACKING: 'https://traegergrills.com/data/contentTypes/orderTracking.json',
  VERTICAL_CAROUSEL: 'https://traegergrills.com/data/contentTypes/verticalCarousel.json',
  PRODUCT_ACCORDION: 'https://traeger.com/v2/productFeatures.json',
  TABBED_FEATURE_COMPARISON: 'https://traeger.com/v2/component/tabbedFeatureComparison.json',
  GRILL_CAPACITY_AND_SPECS: 'https://traegergrills.com/data/contentTypes/grillCapacityAndSpecs.json',
  PRODUCT_FEATURES: 'https://traegergrills.com/data/contentTypes/productFeatures.json',
  SCROLL_SEQUENCE: 'https://traeger.com/v2/component/scrollSequence.json',
  STICKY_NAV_WITH_LINKS: 'https://traegergrills.com/data/contentTypes/stickyNavWithLinks.json',
  TEXT_CONTENT_COLUMNS: 'https://traegergrills.com/data/contentTypes/textContentColumns.json',
  TITLED_CONTENT_MULTIPLE_COLUMNS: 'https://traegergrills.com/data/contentTypes/titledContentMultipleColumns.json',
  IMAGE_MASK: 'https://traeger.com/v2/component/imageMask.json',
  SERIES_HERO: 'https://traegergrills.com/data/contentTypes/seriesHero.json',
  FULL_WIDTH_ASSET_CAROUSEL: 'https://traegergrills.com/data/contentTypes/fullWidthAssetCarousel.json',
  CUSTOMIZE_GRID: 'https://traeger.com/v2/customizeGrid.json',
  LOGO_CAROUSEL: 'https://traegergrills.com/data/contentTypes/logoCarousel.json',
  DELIVERY_AND_ASSEMBLY: 'https://traegergrills.com/data/contentTypes/deliveryAndAssembly.json',
  ALL_GRILLS_HERO: 'https://traegergrills.com/data/contentTypes/allGrillsHero.json',
  CATEGORY_SLIDER: 'https://traegergrills.com/data/contentTypes/categorySlider.json',
  FEATURE_CAROUSEL: 'https://traegergrills.com/data/contentTypes/featureCarousel.json',
  NAVIGATION: 'https://traeger.com/v2/data/slot/navigation.json',
  FOOTER: 'https://traegergrills.com/data/slot/footer.json',
  FOOTER_NAV_CARDS: 'https://traegergrills.com/data/contentTypes/footerNavCards.json',
  PHOTO_NAV_CARDS: 'https://traegergrills.com/data/contentTypes/photoNavCards.json',
  HIGHLIGHT_VIDEO_REFERENCE: 'https://traegergrills.com/data/contentTypes/highlightVideoReference.json',
  HOME_HERO: 'https://traegergrills.com/data/contentTypes/homeHero.json',
  FORM: 'https://traegergrills.com/data/contentTypes/form.json',
  PHOTO_GALLERY: 'https://traegergrills.com/data/contentTypes/photoGallery.json',
  QUOTE_CAROUSEL: 'https://traegergrills.com/data/contentTypes/quoteCarousel.json',
  RECIPE_CAROUSEL: 'https://traegergrills.com/data/contentTypes/recipeCarousel.json',
  SIDE_BY_SIDE: 'https://traeger.com/v2/sideBySide.json',
  SPLIT_TOUT_CONTENT: 'https://traegergrills.com/data/contentTypes/splitToutContent.json',
  TOUT_CONTENT_WITH_MARKDOWN: 'https://traegergrills.com/data/contentTypes/toutContentWithMarkdown.json',
  TITLED_SPLIT_TOUT_CONTENT: 'https://traegergrills.com/data/contentTypes/titledSplitToutContent.json',
  TWO_THIRDS_GENERAL_CONTENT: 'https://traegergrills.com/data/contentTypes/generalTwoThirdSplitContent.json',
  WOOD_PELLET_FLAVORS: 'https://traegergrills.com/data/contentTypes/woodPelletFlavors.json',
  VIDEO_FADE_HERO: 'https://traegergrills.com/data/contentTypes/videoFadeHero.json',
  COUNTDOWN_COMPONENT: 'https://traeger.com/v2/countdownComponent.json',
  CODE_REDEMPTION: 'https://traeger.com/v2/codeRedemption.json',

  // views
  ORDER_CONFIRMATION: 'https://traeger.com/v2/orderDetail.json',
  RESET_PASSWORD: 'https://traegergrills.com/data/contentTypes/userResetPassword.json',
  SEARCH_RESULTS_BODY: 'https://traegergrills.com/data/slot/searchResultsBody.json',
  CART: 'https://traegergrills.com/data/contentTypes/basket.json',
} as const

export const SCHEMA_IDS = {
  ...SERVER_SCHEMA_IDS,
  ...CLIENT_SCHEMA_IDS,
} as const

export type ServerSchemaId = typeof SERVER_SCHEMA_IDS[keyof typeof SERVER_SCHEMA_IDS];
export type ClientSchemaId = typeof CLIENT_SCHEMA_IDS[keyof typeof CLIENT_SCHEMA_IDS];
export type SchemaId = ServerSchemaId | ClientSchemaId;
